
import { Modal, Form, Button } from "react-bootstrap";
import { Space, Select, Avatar, DatePicker } from "antd";
import { UserOutlined } from "@ant-design/icons";


interface LeadTransferExportModalProps {
    showExportModal: any;
    setShowExportModal: any;
    handleCloseExportModal: any;
    exportStartDate: any;
    setExportStartDate: any;
    exportEndDate: any;
    setExportEndDate: any;
    exportLoading: any;
    handleExportTransferList: any;
    exportTransferFrom: any;
    exportTransferTo: any;
    setExportTransferFrom: any;
    setExportTransferTo: any;
    employeeOptions: any;

}

const LeadTransferExportModal: React.FC<LeadTransferExportModalProps> = ({
    showExportModal,
    setShowExportModal,
    handleCloseExportModal,
    exportStartDate,
    setExportStartDate,
    exportEndDate,
    setExportEndDate,
    exportLoading,
    handleExportTransferList,
    exportTransferFrom,
    exportTransferTo,
    setExportTransferFrom,
    setExportTransferTo,
    employeeOptions
}) => {


    return <Modal show={showExportModal} onHide={handleCloseExportModal} size="lg">
        <Modal.Header closeButton>
            <Modal.Title>Export Transfer List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Form>
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>Start Date <span className="text-danger">*</span></Form.Label>
                            <DatePicker
                                value={exportStartDate}
                                onChange={(date) => setExportStartDate(date)}
                                format="DD MMM YYYY"
                                placeholder="Select start date"
                                className="w-100"
                                style={{ height: '38px' }}
                                allowClear
                            />
                            {!exportStartDate && (
                                <div className="text-danger small mt-1">Start date is required</div>
                            )}
                        </Form.Group>
                    </div>

                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>End Date <span className="text-danger">*</span></Form.Label>
                            <DatePicker
                                value={exportEndDate}
                                onChange={(date) => setExportEndDate(date)}
                                format="DD MMM YYYY"
                                placeholder="Select end date"
                                className="w-100"
                                style={{ height: '38px' }}
                                allowClear
                                disabledDate={(current) => {
                                    if (!exportStartDate || !current) return false;
                                    return current.isBefore(exportStartDate, 'day');
                                }}
                            />
                            {!exportEndDate && (
                                <div className="text-danger small mt-1">End date is required</div>
                            )}
                        </Form.Group>
                    </div>

                </div>

                <div className="row">
                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>Transfer From</Form.Label>
                            <Select
                                size="large"
                                style={{ width: "100%" }}
                                placeholder="Select Employee"
                                allowClear
                                showSearch
                                value={exportTransferFrom}
                                onChange={(value) => setExportTransferFrom(value)}
                                dropdownStyle={{ zIndex: 9999 }}
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={employeeOptions}
                                optionRender={(option) => (
                                    <Space>
                                        {option?.data?.image_url && (
                                            <Avatar
                                                size="small"
                                                src={option?.data?.image_url || undefined}
                                                icon={<UserOutlined />}
                                            />
                                        )}
                                        <span>{option.label}</span>
                                    </Space>
                                )}
                            />
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group className="mb-3">
                            <Form.Label>Transfer To</Form.Label>
                            <Select
                                size="large"
                                style={{ width: "100%" }}
                                placeholder="Select Employee"
                                allowClear
                                showSearch
                                value={exportTransferTo}
                                onChange={(value) => setExportTransferTo(value)}
                                dropdownStyle={{ zIndex: 9999 }}
                                filterOption={(input, option: any) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                options={employeeOptions}
                                optionRender={(option) => (
                                    <Space>
                                        {option?.data?.image_url && (
                                            <Avatar
                                                size="small"
                                                src={option?.data?.image_url || undefined}
                                                icon={<UserOutlined />}
                                            />
                                        )}
                                        <span>{option.label}</span>
                                    </Space>
                                )}
                            />
                        </Form.Group>
                    </div>
                </div>

                <div className="alert alert-info mb-0">
                    <i className="ti ti-info-circle me-2"></i>
                    This will export all todo records matching the selected filters. Large date ranges may take longer to process.
                </div>
            </Form>
        </Modal.Body>
        <Modal.Footer>
            <Button
                variant="secondary"
                onClick={() => setShowExportModal(false)}
                disabled={exportLoading}
            >
                Cancel
            </Button>
            <Button
                variant="primary"
                onClick={handleExportTransferList}
                disabled={exportLoading || !exportStartDate || !exportEndDate}
            >
                {exportLoading ? (
                    <>
                        <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                        Exporting...
                    </>
                ) : (
                    <>
                        <i className="ti ti-download me-1"></i> Export Todos
                    </>
                )}
            </Button>
        </Modal.Footer>
    </Modal>
}

export default LeadTransferExportModal;